import React from 'react';

const GoogleMap = () => {
  return (
    <div className="h-[400px] w-full rounded-lg overflow-hidden">
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2795.683454122536!2d9.174432876144905!3d45.51645047107486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c09556b5094d%3A0x94ce7562a4d553f6!2sGalimberti%20Lorenzo!5e0!3m2!1sit!2sit!4v1735993451533!5m2!1sit!2sit"
        className="border-0 w-full h-full rounded-lg"
        allowFullScreen=""
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default GoogleMap;
